export const rad2Deg = v => {
  return v * 180 / Math.PI
}

export const deg2Rad = v => {
  return v * Math.PI / 180
}

export const polar2Cartesan = (r, t /* rad */) => ({
  x: r * Math.cos(t),
  y: r * Math.sin(t)
})

export const cartesan2Polar = (x, y) => ({
  r: Math.sqrt(x * x, y * y),
  t: Math.atan2(y, x) // rad
})

export const len = (x1, y1, x2, y2) => {
  return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1))
}

export const angle = (x1, y1, x2, y2) => {
  const y = Math.sin(y2 - y1) * Math.cos(x2)
  const x = Math.cos(x1) * Math.sin(x2) - Math.sin(x1) * Math.cos(x2) * Math.cos(y2 - y1)
  let brng = Math.atan2(y, x)

  brng = rad2Deg(brng)
  return brng < 0 ? brng + 360 : brng
}



// WEBPACK FOOTER //
// ./src/utils/math.js